import { render } from "./NPartners.vue?vue&type=template&id=64127afb&scoped=true&ts=true"
import script from "./NPartners.vue?vue&type=script&lang=ts"
export * from "./NPartners.vue?vue&type=script&lang=ts"

import "./NPartners.vue?vue&type=style&index=0&id=64127afb&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64127afb"]])

export default __exports__